<template>
    <div class="JobExperienceForm relative space-y-5">
        <CFormGroup label="Názov pozície">
            <CFormInput
                :disabled="disabled"
                :has-suffix="$attrs['hasSuffix']"
                placeholder="napr. CEO, zakladateľ/ka, špecialista/ka procesov, ..."
                :suffix-icon="$attrs['suffixIcon']"
                :model-value="modelValue.position"
                @update:model-value="update({ position: $event })"
            />
        </CFormGroup>

        <CFormGroup label="Spoločnosť">
            <CFormInput
                :disabled="disabled"
                :has-suffix="$attrs['hasSuffix']"
                :suffix-icon="$attrs['suffixIcon']"
                :model-value="modelValue.org"
                @update:model-value="update({ org: $event })"
            />
        </CFormGroup>

        <CFormGroup label="Mesto">
            <CFormInput
                :disabled="disabled"
                :has-suffix="$attrs['hasSuffix']"
                :suffix-icon="$attrs['suffixIcon']"
                :model-value="modelValue.address"
                @update:model-value="update({ address: $event })"
            />
        </CFormGroup>

        <YearsRangeInput
            :disabled="disabled"
            end-label="Koniec"
            :end-year="modelValue.endYear"
            start-label="Začiatok"
            :start-year="modelValue.startYear"
            @change="update($event)"
        />

        <CFormGroup label="Popis">
            <CWysiwyg
                :allowed-buttons="['back', 'forward', 'bold', 'italic', 'strike', 'orderedList', 'bulletList']"
                :disabled="disabled"
                :model-value="modelValue.desc"
                @update:model-value="update({ desc: $event })"
            />
        </CFormGroup>
    </div>
</template>

<script setup lang="ts">
import type { JobPosition } from '#shared/types/User'

const props = defineProps<{
    modelValue: JobPosition
    disabled?: boolean
}>()

const emit = defineEmits<{
    'update:model-value': [value: JobPosition]
}>()

const update = (change: Partial<JobPosition>) => {
    emit('update:model-value', { ...props.modelValue, ...change })
}
</script>